import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/general/scheduleReportActions'
import { Button, Form, Checkbox, AutoComplete, Input, Icon, Spin } from 'antd'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import ListItems from '../../../components/reports/general/schedule-report/ListItems'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config

const propTypes = {}
const FormItem = Form.Item
const CheckboxGroup = Checkbox.Group

class ScheduleReportContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      checkAll: false,
      plainOptions: [
        'Specialty',
        'New Construction',
        'Material Sale',
        'Modernization',
        'Maintenance/Service',
        'Repair'
      ]
    }

    // get job list
    this.props.scheduleReportGetJobList({})
  }

  onChange = (date, dateString) => {
    this.setState({
      filter: dateString
    })
  }

  handleJobSearch = _.debounce(value => {
    this.props.scheduleReportGetJobList({
      filters: {
        name: value
      }
    })
  }, 500)

  onChangeCheckboxGroup = checkedList => {
    this.setState({
      checkedList,
      checkAll: checkedList.length === this.state.plainOptions.length
    })
  }

  applyFilter = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.scheduleReportGetFullReport({ filters: values })
    })
  }

  onCheckAllChange = e => {
    const { form } = this.props
    form.setFieldsValue({
      types: e.target.checked ? this.state.plainOptions : []
    })
    this.setState({
      checkedList: e.target.checked ? this.state.plainOptions : [],
      checkAll: e.target.checked
    })
  }

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = _.omit(values, 'date_range')

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/general/schedule-report/print?${qs}`
      window.open(url, '_blank')
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const jobListData = _.get(this.props, 'scheduleReportActions.jobList.data')
    const loadingJobList = _.get(this.props, 'scheduleReportActions.loadingJobList')

    const loadingFullReport = _.get(this.props, 'scheduleReportActions.loadingFullReport')
    const fullReport = _.get(this.props, 'scheduleReportActions.fullReport.data')

    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Schedules</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-6">
              <div className="row">
                <div className="col-6">
                  <Spin spinning={loadingJobList}>
                    <FormItem label="Job">
                      {getFieldDecorator('job_id', {})(
                        <AutoComplete
                          dataSource={convertToOption(jobListData)}
                          onChange={this.handleJobSearch}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Job"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
            </div>
            <div className="col-6">
              <FormItem label="Select types:">
                {getFieldDecorator('types', {
                  initialValue: this.state.checkedList
                })(
                  <CheckboxGroup
                    options={this.state.plainOptions}
                    onChange={this.onChangeCheckboxGroup}
                    className="open-container-row"
                  />
                )}
              </FormItem>
              <div style={{ borderTop: '1px solid #E9E9E9' }}>
                <Checkbox
                  indeterminate={this.state.indeterminate}
                  onChange={this.onCheckAllChange}
                  checked={this.state.checkAll}
                >
                  Check all
                </Checkbox>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems fullReport={fullReport} loadingFullReport={loadingFullReport} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ scheduleReportActions, authentication }, ownProps) => ({
  scheduleReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

ScheduleReportContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(ScheduleReportContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/general/ScheduleReportContainer.js